export type FilterOperators = "equals" | "in" | "range" | "notEquals";

export type FilterableColumn = {
  columnId: string;
  columnHeader: string;
  columnType: "text" | "select" | "date";
  columnOptions?: string[];
  accessorFn?: (row: any) => any;
};

export type FilterRule = {
  columnId: string;
  operator: FilterOperators;
  value?: string | number;
  startDate?: Date;
  endDate?: Date;
};

export function getFilteredData<T>(
  data: T[],
  filterRules: FilterRule[],
  filterableColumns: FilterableColumn[]
): T[] {
  if (!filterRules || filterRules.length === 0) return data;

  return data.filter((row) => {
    return filterRules.every((rule) => {
      const column = filterableColumns.find(
        (col) => col.columnId === rule.columnId
      );

      if (!column || !column.accessorFn) {
        return true;
      }

      const rowValue = column.accessorFn(row);

      switch (rule.operator) {
        case "equals":
          return String(rowValue) === String(rule.value);

        case "in":
          return String(rowValue)
            .toLowerCase()
            .includes(String(rule.value).toLowerCase());

        case "notEquals":
          return String(rowValue) !== String(rule.value);

        case "range":
          if (rule.startDate && rule.endDate) {
            const valueAsDate =
              rowValue instanceof Date ? rowValue : new Date(rowValue);
            return valueAsDate >= rule.startDate && valueAsDate <= rule.endDate;
          }
          return false;

        default:
          return true;
      }
    });
  });
}
